import { enableLine1pxOptimize } from '@byted/light-render/lib/utils/line1px';
export { default as Marker } from '@byted/light-render/lib/shapes/Marker';
export { createRichText as createText } from '../rich';
export { default as SymbolShape } from './SymbolShape';
export { Line, Rect, Arc, Circle, Ellipse, Element, DOMNode, Shape as Component, Sector, Path, Polygon, CompoundPath, Polyline, Text, Group, Image, LinearGradient, RadialGradient, ConicGradient, Pattern, createRef, RichText, } from '@byted/light-render';
export { default as Zoomable } from './zoomable';
enableLine1pxOptimize();
